// extracted by mini-css-extract-plugin
export var fadeInDown = "mobile-menu-links-module--fadeInDown--c3bcc";
export var fadeInDropdown = "mobile-menu-links-module--fadeInDropdown--2454c";
export var fadeInUp = "mobile-menu-links-module--fadeInUp--df862";
export var fadeOutDropdown = "mobile-menu-links-module--fadeOutDropdown--7f510";
export var link = "mobile-menu-links-module--link--e94e4";
export var menuLinks = "mobile-menu-links-module--menuLinks--d9a84";
export var oneSection = "mobile-menu-links-module--oneSection--9328b";